import React, { useEffect, useState, useMemo, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../Header/AppHeader';
import moment from 'moment';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../QuotationRecords/QuotationStyle.css';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import DataExport from '../Common/Export';
import DataTable from '../Common/DataTableList';

const InvoiceRecords = () => {

    const { CurrentTheme } = useContext(ThemeContext);

    const [InvoiceData, setInvoiceData] = useState([]);
    const [SelectedOption, setSelectedOption] = useState(0);

    useEffect(() => {
        FetchInvoices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const Failure = (err) => {
        FailureAlert(err);
    };

    const InvoiceDataSuccess = (data) => {
        setInvoiceData(data);
    };

    const setInvoiceOptionCriteria = (SelectedOption) => {
        let OptionsData = [];
        let option = parseInt(SelectedOption);
        if (option > 0 && option !== 4) {
            InvoiceData.filter(q => q.Status === option).forEach(Invoice => {
                OptionsData.push(Invoice);
            }
            );
        }
        else if (option === 4) {
            InvoiceData.filter(q => q.InvoiceCredit !== null && q.InvoiceCredit > 1).forEach(Invoice => {
                OptionsData.push(Invoice);
            }
            );
        }

        return OptionsData;
    };

    const InvoiceOption = useMemo(() => {
        return setInvoiceOptionCriteria(SelectedOption);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [SelectedOption]);

    const FetchInvoices = () => {
        Axiosfetch(baseURL + "GetActiveInvoices", "GET", null, InvoiceDataSuccess, Failure);
    };

    const exportToCSV = () => {

        if (InvoiceOption.length > 0) {
            const csvData = [];

            InvoiceOption.map((invoice, index) => {
                return csvData.push({
                    SI: (index + 1),
                    ID: invoice.InvoiceID + "_" + moment(invoice.createdAt).local().format("DDMMYYYY"),
                    QuotationID: invoice.Quotation[0].QuoteID + "/" + moment(invoice.Quotation[0].createdAt).local().format("DDMMYYYY"),
                    InterState: invoice.InterState === 1 ? "Yes" : "No",
                    CGST: invoice.CGST,
                    SGST: invoice.SGST,
                    IGST: invoice.IGST,
                    Credit: invoice.InvoiceCredit === 1 ? "Full Payment" : "Partial payment",
                    //Remarks: invoice.Remarks,
                    CreatedDate: invoice.CreatedAt
                });

            });

            DataExport(csvData, "InvoiceRecords");
        }
        else {
            Alert.error("No Data To Export", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const columns = [
        {
            name: 'Invoice#',
            selector: row => row.InvoiceID ?
                <NavLink target="_blank" title="Click to see Quotation" rel="noopener noreferrer" to={`/GenerateInvoice/${row.InvoiceID}`}>
                    {row.InvoiceID + "_" + moment(row.createdAt).local().format("DDMMYYYY")}</NavLink> : "-",
            sortable: true,
        },
        {
            name: 'Quotation',
            width: "150px",
            selector: row => row.Quotation && row.Quotation.length > 0 && row.Quotation[0].QuoteID ?
                <NavLink target="_blank" title="Click to see Quotation" rel="noopener noreferrer" to={`/GenerateQuotation/${row.Quotation[0].QuoteID}`}>{row.Quotation[0].QuoteID + "_" + moment(row.Quotation[0].createdAt).local().format("DDMMYYYY")}</NavLink> : "-",
            sortable: true,
        },
        {
            name: 'InterState',
            selector: row => row.InterState === 1 ? "Yes" : "No",
            sortable: true,
        },
        {
            name: 'CGST',
            selector: row => row.CGST,
            sortable: true,
        },
        {
            name: 'SGST',
            selector: row => row.SGST,
            sortable: true,
        },
        {
            name: 'IGST',
            selector: row => row.IGST,
            sortable: true,
        },
        {
            name: 'Credit',
            width: "180px",
            selector: row => {
                return <div style={{ whiteSpace: "normal" }}>{row.InvoiceCredit === 1 ? "Full Payment" : "Partial Payment"}</div>
            },
            sortable: true,
        },
        {
            name: 'Remarks',
            selector: row => row.Remarks,
            sortable: true,
        },
        {
            name: 'Created Date',
            width: "250px",
            selector: row => moment(row.CreatedAt).local().format("DD/MM/YYYY hh:mm:ss A"),
        }
    ];

    return (
        <div>
            <Header></Header>
            <div style={{ border: "none", boxShadow: "none" }} className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-4 col-md-4 col-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Invoice Records</h5>
                    </div>
                    <div className={`${parseInt(process.env.REACT_APP_EXPORT_REQUIRED) === 1 ? "col-md-3 col-10 align-right" : "col-md-4 col-10 align-right"}`}>
                        <div className="basic-select">
                            <select className="DropdownStyle" onChange={(e) => setSelectedOption(parseInt(e.target.value))}>
                                <option value="0">Select Option</option>
                                <option value="1">All Invoice</option>
                                <option value="4">With Payment Logs</option>
                            </select>
                        </div>
                    </div>
                    {parseInt(process.env.REACT_APP_EXPORT_REQUIRED) === 1 && (<div className="col-md-1 col-2 align-left">
                        <span data-tip="Export Quotation" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={exportToCSV}>
                            <FontAwesomeIcon icon={faFileExcel} />
                        </span>
                    </div>)}
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <DataTable columns={columns} data={InvoiceOption}></DataTable>
                </div>
            </div>
        </div>
    );
};

export default InvoiceRecords;